export default __webpack_public_path__ + "static/media/iq.f0039f66.svg";